import React from 'react'

import { IconComponent } from '../../../../types'

export const HaqqNakked: IconComponent = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" fill="none" viewBox="0 0 128 128" {...props}>
      <g clipPath="url(#clip0_1006_159)">
        <mask
          id="mask0_1006_159"
          style={{ maskType: 'luminance' }}
          width="80"
          height="80"
          x="24"
          y="24"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M104 24H24v80h80V24z"></path>
        </mask>
        <g mask="url(#mask0_1006_159)">
          <mask
            id="mask1_1006_159"
            style={{ maskType: 'alpha' }}
            width="80"
            height="80"
            x="24"
            y="24"
            maskUnits="userSpaceOnUse"
          >
            <path
              fill="#D9D9D9"
              d="M64 24l12.246 10.436 16.038 1.28 1.28 16.038L104 64 93.564 76.246l-1.28 16.038-16.038 1.28L64 104 51.754 93.564l-16.038-1.28-1.28-16.038L24 64l10.436-12.246 1.28-16.038 16.038-1.28L64 24z"
            ></path>
          </mask>
          <g mask="url(#mask1_1006_159)">
            <path fill="#0D0D0E" d="M108.381 13.037H20.709v103.014h87.672V13.037z"></path>
            <g filter="url(#filter0_f_1006_159)">
              <path
                fill="#002E48"
                d="M540.14-307.62C401.232-145.051 9.05 160.637-448.413 82.845-291.095 242.437 126.86 387.773 540.14-307.62z"
              ></path>
            </g>
            <g filter="url(#filter1_f_1006_159)">
              <path
                fill="#0072A3"
                d="M439.191-228.64C326.537-96.783 8.47 151.15-362.56 88.03c127.6 129.456 466.59 247.361 801.751-316.67z"
              ></path>
            </g>
            <g filter="url(#filter2_f_1006_159)">
              <path
                fill="#00C2CE"
                d="M439.193-228.639C326.538-96.782 22.34 197.782-362.559 88.031c127.6 129.456 473.91 221.505 801.752-316.67z"
              ></path>
            </g>
            <g filter="url(#filter3_f_1006_159)">
              <path
                fill="#EF6619"
                d="M487.156-248.63C354.519-111.85 1.016 197.687-409.768 120.052-280.628 236.32 89.478 299.655 487.156-248.63z"
              ></path>
            </g>
            <g filter="url(#filter4_f_1006_159)">
              <path
                fill="#CF7154"
                d="M439.193-228.638C326.538-96.781 31.803 229.426-362.559 88.032c124.423 98.564 468.115 204.34 801.752-316.67z"
              ></path>
            </g>
            <g filter="url(#filter5_f_1006_159)">
              <path
                fill="#F1F9A0"
                d="M439.192-228.639C326.538-96.782 48.415 272.572-362.559 88.031c170.694 102.22 473.037 137.163 801.751-316.67z"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_1006_159"
          width="1030.73"
          height="564.962"
          x="-469.503"
          y="-328.71"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_1006_159" stdDeviation="10.545"></feGaussianBlur>
        </filter>
        <filter
          id="filter1_f_1006_159"
          width="843.931"
          height="466.19"
          x="-383.65"
          y="-249.73"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_1006_159" stdDeviation="10.545"></feGaussianBlur>
        </filter>
        <filter
          id="filter2_f_1006_159"
          width="843.931"
          height="458.361"
          x="-383.649"
          y="-249.729"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_1006_159" stdDeviation="10.545"></feGaussianBlur>
        </filter>
        <filter
          id="filter3_f_1006_159"
          width="985.97"
          height="536.748"
          x="-454.291"
          y="-293.153"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_1006_159" stdDeviation="22.262"></feGaussianBlur>
        </filter>
        <filter
          id="filter4_f_1006_159"
          width="843.931"
          height="440.038"
          x="-383.649"
          y="-249.728"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_1006_159" stdDeviation="10.545"></feGaussianBlur>
        </filter>
        <filter
          id="filter5_f_1006_159"
          width="843.931"
          height="423.427"
          x="-383.649"
          y="-249.729"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feGaussianBlur result="effect1_foregroundBlur_1006_159" stdDeviation="10.545"></feGaussianBlur>
        </filter>
        <clipPath id="clip0_1006_159">
          <path fill="#fff" d="M0 0H80V80H0z" transform="translate(24 24)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}
